import classnames from "classnames";
import React from "react";
import ReactPaginate from "react-paginate";

import Package from "./package/Package";

class ResultsList extends React.Component {
  packages = () => {
    const { props } = this;

    return props.loadedResults.map(result => {
      const { images = {}, package: pkg, bookable_online: isBookOnline } = result;
      const { _id: packageId } = pkg;
      const offerId = `${result.slug}-${packageId}`;

      return (
        <Package
          key={offerId}
          id={packageId}
          offerId={offerId}
          highlightOffer={props.highlightOffer}
          price={pkg.price}
          nights={pkg.nights}
          rounds={pkg.rounds}
          roundsDetails={pkg.round_allocations}
          boardBasis={pkg.board_basis}
          transportation={pkg.transportation}
          notes={pkg.notes}
          promotions={pkg.special_offers}
          isBookOnline={isBookOnline}
          arrivalDate={props.arrivalDate}
          venueImageUrlPalmAndUp={images.palmAndUp}
          venueImageUrlSmallPalm={images.smallPalm}
          venueLat={parseFloat(result.lat)}
          venueLon={parseFloat(result.lon)}
          venueName={result.name}
          venueRegionName={result.place}
          venueReviewCount={result.reviews}
          venueStarRating={parseFloat(result.rating)}
          venueUrl={result.slug}
          isFeatured={result.featured}
          isHighlighted={props.highlightedOfferId === offerId}
          isMapView={props.isMapView}
          isSignatureCollection={result.signature_collection}
          fallbackNumber={props.fallbackNumber}
          fallbackNumberHref={props.fallbackNumberHref}
        />
      );
    });
  };

  nextLabel = () => (<span>Next &raquo;</span>);

  previousLabel = () => (<span>&laquo; Previous</span>);

  renderPackages = () => {
    const { length } = this.props.loadedResults;
    const component = `packages-section`;
    const { isMapView } = this.props;

    return (
      <article
        aria-label="Packages List"
        data-component={component}
        data-landscape={isMapView ? "" : null}
      >
        {(length === 1 || isMapView) && this.packages()}
        {(length !== 1 && !isMapView) && (
          <section data-component="packages-collection">
            {this.packages()}
          </section>
        )}
      </article>
    );
  };

  renderPagination = () => {
    const self = this;
    const { props } = self;
    const { isMapView } = props;

    return props.pageCount > 1 && (
      <ReactPaginate
        pageCount={props.pageCount}
        pageRangeDisplayed={isMapView ? 2 : 3}
        marginPagesDisplayed={isMapView ? 1 : 2}
        previousLabel={self.previousLabel()}
        nextLabel={self.nextLabel()}
        breakClassName="disabled hide-handheld"
        onPageChange={props.handlePageClick}
        forcePage={props.page - 1}
        containerClassName="search-pagination list-bare"
        pageClassName="hide-handheld"
        activeClassName="active"
      />
    );
  };

  render = () => (
    <div
      className={classnames(
        "layout__item",
        this.props.isMapView && "map-view u-1/2-lap u-2/5-desk"
      )}
      id="js-search-list"
    >
      {this.renderPackages()}
      {this.renderPagination()}
    </div>
  );
}

export default ResultsList;



// WEBPACK FOOTER //
// ./components/search/ResultsList.jsx